import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/privacy")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "en",
    title: "Privacy Policy: Shugert",
    description: "How Shugert Agency collects, uses, and protects your personal data on shugert.com.mx, in line with GDPR, UK GDPR, and Mexico's LFPDPPP.",
    path: "/privacy",
    altPath: alternatePath("/privacy", "es"),
  }),
});